// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"253":"1c1f8b13","528":"ec546760","578":"c5f45390","740":"9bb0e560","821":"96c727f6","962":"488e8b9f","964":"e320140e"}[chunkId] + ".css";
};